import "./App.css";
import Login from "./page/Login";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import liff from "@line/liff";
import { useState, useEffect, useContext } from "react";
import ForgetPassword from "./page/ForgetPassword";
import VerificationCode from "./page/VerificationCode";
import ResetPassword from "./page/ResetPassword";
import Layout from "./components/Layout";
import ReferralDataList from "./page/ReferralDataList";
import FirstLogin from "./page/FirstLogin";
import ReferralAddData from "./page/ReferralAddData";
import HistoryListData from "./page/HistoryListData";
import ReferralEditData from "./page/ReferralEditData";
import DrawerComponent from "./components/DrawerComponent";
import PrivacyPolicy from "./page/PrivacyPolicy";
import DoctorSchedule from "./page/DoctorSchedule";
import DutySchedule from "./page/DutySchedule";
import AccountManageList from "./page/AccountManageList";
import AccountEdit from "./page/AccountEdit";
import AccountAdd from "./page/AccountAdd";
import TempAccount from "./page/TempAccount";
import TempLogin from "./page/TempLogin";
import HospitalManageList from "./page/HospitalManageList";
import HospitalEdit from "./page/HospitalEdit";
import HospitalAdd from "./page/HospitalAdd";
import { AuthContext } from "./contexts/AuthContext";
import { useQuery, useQueryClient } from "react-query";

import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { ToastContainer, toast } from "react-toastify";

import { v4 as uuidv4 } from "uuid";

import "react-toastify/dist/ReactToastify.css";

import Logger from "./libraries/Logger";
import apiClient from "./libraries/ApiClient";

//test
function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const [userId, setUserId] = useState("");
  const [token, setToken] = useState(null);
  const [action, setAction] = useState("");
  const [rowId, setRowId] = useState("");
  const [liffLoading, setLiffLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [noticeData, setNoticeData] = useState(null);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [connection, setConnection] = useState();
  const [pathName, setPathName] = useState("");

  const { logout, setMyAuth, loginAfter, setLoginAfter, myAuth } =
    useContext(AuthContext);
  const { AccountRowId: accountRowId } = myAuth;
  const { HospitalCode } = myAuth;

  const id = import.meta.env.VITE_LINE_LIFF_ID;

  // signalR開關
  const signalrActive = import.meta.env.VITE_SIGNALR_ACTIVE;
  const signalrActiveBoolean =
    signalrActive && signalrActive.toLowerCase() === "true";
  // signalR開關

  useEffect(() => {
    setLiffLoading(true);
    liff
      .init({ liffId: id })
      .then(() => {
        if (liff.isInClient()) {
          // liff.getProfile().then((profile) => {
          //   setUserId(profile.userId);
          // });
          setUserId(liff.getAccessToken());
        }
        setLiffLoading(false);
      })
      .catch(() => {
        setLiffLoading(false);
      });
  }, []);

  // liff
  //   .init({
  //     liffId: id,
  //   })
  //   .then(() => {
  //     console.log("liff success");
  //     if (liff.isInClient()) {
  //       // liff.getProfile().then((profile) => {
  //       //   setUserId(profile.userId);
  //       // });
  //       setUserId(liff.getAccessToken());
  //     }
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });
  // useEffect(() => {
  //   setUserId("eyJhbGciOiJIUzI1NiJ9.GwvAkv6BPJHlo8iQVkc6qRJt0sfr8gbwzFJz4KnddDNaJq1ZSbg17RG9IcMA8B08IG-W-DMAK5TJaTVreGrLUAz_-_W8fYm25T2fjmCZf8tbxCyhWPN54YBJeexSf_nn.Ix9DkZj8gOPCmTyIl7nnzuJWGscWOFJDDWCUDmGqF_Y")
  // }, []);

  useEffect(() => {
    setPathName(location.pathname);
    const params = new URLSearchParams(location.search);
    setAction(params.get("action"));
    setRowId(params.get("rowId"));
  }, [location]);

  // useEffect(() => {
  //   if (open) {
  //     setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  //   }
  // }, [open]);

  useEffect(() => {
    let timeoutId;

    function resetTimeout() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsLoggedIn(false);
      }, 3600000); //1小時自動登出
    }

    function handleMousemove() {
      resetTimeout();
    }

    function handleKeydown() {
      resetTimeout();
    }

    resetTimeout();
    window.addEventListener("mousemove", handleMousemove);
    window.addEventListener("keydown", handleKeydown);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("mousemove", handleMousemove);
      window.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      logout();
      closeConnection();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    setLoginAfter(location.pathname);
  }, []);

  useEffect(() => {
    const backEndActionId = localStorage.getItem("backEndActionId");
    if (!backEndActionId) {
      localStorage.setItem("backEndActionId", uuidv4());
    }
  }, []);

  const checkLiffId = async ({ queryKey }) => {
    const [_, userId] = queryKey;
    const data = {
      Data: {
        LineUserId: userId,
      },
    };

    const res = await apiClient.postAes(
      "api/login/validation/liff/security",
      data
    );
    return res;
  };

  console.log(location);
  console.log(liff);

  const { data, isLoading: tokenCheckLoading } = useQuery(
    ["checkLiffId", userId],
    checkLiffId,
    {
      enabled: userId !== "",
      onSuccess: (data) => {
        const { Data: AuthData } = data.data || {};
        const {
          Account,
          AccountRowId,
          Token,
          Name,
          Result,
          Menus,
          Identities,
          OrganizationName,
          OrganizationCode,
        } = AuthData || {};

        if (Result === 1) {
          const LocalstorageData = {
            authorized: true,
            AccountRowId: AccountRowId,
            Name: Name,
            Account: Account,
            Token: Token,
            Menu: Menus,
            SelfIdentities: Identities?.landseed_zonedefense_tbc,
            OtherIdentities: Identities?.other_zonedefense_tbc,
            Hospital: OrganizationName,
            HospitalCode: OrganizationCode,
          };

          // Logger.LogOfInfoWithIdentity("LineID登入Token", Token);

          const actionUuid = uuidv4();
          localStorage.setItem("actionUuid", actionUuid);
          localStorage.setItem("auth", JSON.stringify(LocalstorageData));
          setMyAuth({ ...LocalstorageData, authorized: true });
          // if (location.pathname !== "/ReferralEditData") {
          //   navigate("/ReferralDataList");
          // }
          if (action === "referraladd") {
            navigate("/ReferralAddData");
            return;
          } else if (action === "querypatient" || action === "referralreply") {
            navigate("/ReferralDataList");
            return;
          } else if (action === "referralfeedback") {
            navigate("/History");
            return;
          } else if (action === "referraledit") {
            navigate("/ReferralEditData?rowId=" + rowId);
            return;
          } else {
            console.log("trstrdfsgsdggfdg");
          }
        }
      },
    }
  );

  const SignalR = async () => {
    try {
      const connection = new HubConnectionBuilder()
        .withUrl(`${import.meta.env.VITE_API_ROOT_URL}` + "referralHub")
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build();

      connection.on("test", (data, data1) => {
        setTest(data1);
      });

      if (accountRowId !== "") {
        await connection.start();
        await connection.invoke("Register", accountRowId);
      }

      connection.on(
        "TbcReferralRenewList",
        (OriginalOrganizationCode, TransferOrganizationCode) => {
          if (
            HospitalCode === OriginalOrganizationCode ||
            HospitalCode === TransferOrganizationCode
          ) {
            queryClient.invalidateQueries("getListData");
          }
        }
      );
      connection.on("TbcReferralRenewData", (RowId) => {
        queryClient.invalidateQueries(["getReferralStatus", RowId]);
        notify();
      });

      connection.on("TbcMessageRedDot", () => {
        queryClient.invalidateQueries(["getNoticeData"]);
      });

      connection.on("AccountRenew", async (RowId, IsDisabled) => {
        if (accountRowId === RowId) {
          if (IsDisabled === "false") {
            notifyThree();
          } else {
            notifyFour();
            logout();
            await connection.invoke("Unregister", accountRowId);
            await connection.stop();
          }
        }
      });

      connection.on("AccountOthersUse", async (RowId, ActionUuid) => {
        let actionUuid = localStorage.getItem("actionUuid");

        apiClient.logOfActionWithoutId("SignalrAccountOthersUse", "ActionId", {
          BackEndActionId: ActionUuid,
          FrontEndActionId: actionUuid,
        });

        if (actionUuid !== "") {
          if (accountRowId === RowId && actionUuid !== ActionUuid) {
            notifyTwo();
            logout();
            await connection.invoke("Unregister", accountRowId);
            await connection.stop();
          }
        }
      });

      setConnection(connection);
    } catch (e) {
      console.log(e.error);
    }
  };
  useEffect(() => {
    if (location.pathname === "/Login") {
      closeConnection();
    }
  }, [connection]);

  useEffect(() => {
    if (signalrActiveBoolean) {
      if (accountRowId !== undefined && accountRowId !== "") {
        SignalR();
      }
    }
  }, [accountRowId]);

  const closeConnection = async () => {
    if (signalrActiveBoolean) {
      await connection.invoke("Unregister", accountRowId);
      await connection.stop();
    }
  };

  const [shouldBlockScroll, setShouldBlockScroll] = useState(true);

  // const handleClick = () => {
  //   if ( sidebarOpen) {
  //      //console.log(123);
  //     setShouldBlockScroll(true);
  //   } else {
  //     setShouldBlockScroll(!shouldBlockScroll);
  //   }
  // };
  useEffect(() => {
    if (sidebarOpen) {
      setShouldBlockScroll(true);
    } else {
      setShouldBlockScroll(!shouldBlockScroll);
    }
  }, [sidebarOpen]);

  // useEffect(() => {
  //   window.addEventListener("resize", handleClick);
  //   return () => {
  //     window.addEventListener("resize", handleClick);
  //   };
  // }, []);

  useEffect(() => {
    if (shouldBlockScroll) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [shouldBlockScroll]);
  const notify = () => {
    toast.success(" 他人已有更新轉診進度或留言!", {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "success1",
    });
  };
  const notifyTwo = () => {
    toast.success("您的帳號已在其他裝置登入，請重新登入並確認帳號安全", {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "success3",
    });
  };

  const notifyThree = () => {
    toast.success("您的帳號資料已被其他管理者修改!", {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "success2",
    });
  };

  const notifyFour = () => {
    toast.success("帳號已被停用!", {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "success2",
    });
  };

  if (tokenCheckLoading || liffLoading) {
    return <h1>tokenCheckLoading....</h1>;
  }

  return (
    <div className="App">
      {/* <div>{isLoggedIn ? "Logged in" : "Logged out"}</div> */}
      {/* <AllContextProviders> */}
      {/* <button onClick={notify}>123</button> */}
      <DrawerComponent open={open} setOpen={setOpen} noticeData={noticeData} />
      <ToastContainer
        enableMultiContainer
        limit={1}
        containerId={"success1"}
        style={{ bottom: "16px" }}
      />
      <ToastContainer
        enableMultiContainer
        limit={1}
        containerId={"success2"}
        style={{ bottom: "16px" }}
      />
      <ToastContainer
        enableMultiContainer
        limit={1}
        containerId={"success3"}
        style={{ bottom: "16px" }}
      />
      <Routes>
        <Route
          element={
            <Layout
              open={open}
              setOpen={setOpen}
              setNoticeData={setNoticeData}
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
              closeConnection={closeConnection}
              connection={connection}
            />
          }
        >
          <Route
            path="/ReferralDataList"
            element={<ReferralDataList lineUserId={userId} />}
          />
          <Route
            path="/ReferralAddData"
            element={<ReferralAddData lineUserId={userId} />}
          />
          <Route
            path="/History"
            element={<HistoryListData lineUserId={userId} />}
          />
          <Route
            path="/ReferralEditData"
            element={<ReferralEditData lineUserId={userId} />}
          />
          <Route
            path="/DoctorSchedule"
            element={<DoctorSchedule />}
            lineUserId={userId}
          />
          <Route
            path="/DutySchedule"
            element={<DutySchedule />}
            lineUserId={userId}
          />
          <Route
            path="/AccountManageList"
            element={<AccountManageList lineUserId={userId} />}
          />
          <Route
            path="/AccountEdit"
            element={<AccountEdit lineUserId={userId} />}
          />
          <Route
            path="/AccountAdd"
            element={<AccountAdd lineUserId={userId} />}
          />
          <Route
            path="/HospitalManageList"
            element={<HospitalManageList lineUserId={userId} />}
          />
          <Route
            path="/HospitalEdit"
            element={<HospitalEdit lineUserId={userId} />}
          />
          <Route
            path="/HospitalAdd"
            element={<HospitalAdd lineUserId={userId} />}
          />
        </Route>
        <Route path="/" element={<Navigate to="/Login" />} />
        {/* element={<Navigate to="/Login" />} */}
        <Route
          path="/Login"
          element={
            <Login
              userId={userId}
              setIsLoggedIn={setIsLoggedIn}
              loginAfter={loginAfter}
              closeConnection={closeConnection}
            />
          }
        />
        <Route path="/ForgetPassword" element={<ForgetPassword />} />
        <Route path="/VerificationCode" element={<VerificationCode />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />
        <Route path="/FirstLogin" element={<FirstLogin />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/TempAccount" element={<TempAccount />} />
        <Route path="/TempLogin" element={<TempLogin />} />
      </Routes>
      {/* </AllContextProviders> */}
    </div>
  );
}

export default App;
